import {
    CONFIG_CHANGED,
    LOGOUT_USER,
    EXPIRE_SESSION
  } from '../actions/types';
import { debugLog, debugWarn } from '../util/debug';
import { getDefaultConf } from '../actions/ConfButtonsActions';

/**
 * Load initial conf from localStorage
 * Falls back to the viewport-aware default (conf-2 on phone, conf-4 elsewhere).
 */
const loadInitialConf = () => {
  try {
    const key = `dview_conf_${window.location.hostname}`;
    const saved = localStorage.getItem(key);
    if (saved && saved.startsWith('conf-') && saved !== 'conf-fs') {
      debugLog('[ConfButtonsReducer] Loaded conf from localStorage:', saved);
      return saved;
    }
  } catch (e) {
    debugWarn('[ConfButtonsReducer] Failed to load conf from localStorage:', e);
  }
  return getDefaultConf(); // Phone → conf-2 (2-up), tablet/desktop → conf-4
};

const INITIAL_STATE = {
  conf: loadInitialConf()
};

export default function confButtonsReducer(state = INITIAL_STATE, action) {
  switch ( action.type ) {
      case CONFIG_CHANGED:
        if(action.payload !== 'conf-fs') {
          return {
            ...state,
            conf: action.payload
          }
        }
        return {
          ...state
        }
      case LOGOUT_USER:
      case EXPIRE_SESSION:
        // Don't reset conf on logout - persist user's preference
        // Conf is stored in localStorage and persists across sessions
        return state;
      default:
          return state;
  };
};
